/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'contas',
        title: 'Assistente de Contas',
        type: 'basic',
        icon: 'mat_outline:support_agent',
        link: '/contas',
    },
    // {
    //     id: 'capacitacao',
    //     title: 'Capacitação',
    //     type: 'basic',
    //     icon: 'mat_outline:play_circle',
    //     link: '/capacitacao',
    // },
    {
        id: 'inadimplentes',
        title: 'Inadimplentes',
        type: 'basic',
        icon: 'mat_outline:app_blocking',
        link: '/inadimplentes',
    },
    {
        id: 'users',
        title: 'Usuários',
        type: 'collapsable',
        icon: 'mat_outline:badge',
        children: [
            {
                id: 'franqueados',
                title: 'Motor de promoções',
                type: 'basic',
                icon: 'mat_outline:sell',
                link: '/usuarios-promocao',
            },
            {
                id: 'admins',
                title: 'Administradores',
                type: 'basic',
                icon: 'mat_outline:engineering',
                link: '/usuarios-administradores',
            },
        ],
    },

    {
        id: 'profile',
        title: 'Perfil',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/perfil',
    },
    {
        id: 'promocoes',
        title: 'Promoções',
        type: 'basic',
        icon: 'heroicons_outline:fire',
        link: 'https://promo.mdovisio.com.br/campaigns',
        target: '_blank',
        externalLink: true,
    },
    {
        id: 'sair',
        title: 'Sair',
        type: 'basic',
        icon: 'heroicons_outline:logout',
        link: '/sair',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
